import ExtensionService from "./ExtensionService";
import * as moment from "moment";
import readXlsxFile from "read-excel-file";

import Excel from "exceljs";
import FileSaver from "file-saver";

let MethodService = {};

var NProgress = require('nprogress');
NProgress.configure({
  trickleSpeed: 1000,
  minimum: 0.2,
});

function blockUi() {
  NProgress.start();
  $("body").css("pointer-events", "none");
}

function unblockUi() {
  setTimeout(() => {
    NProgress.done();
    Ladda.stopAll();
    $("body").css("pointer-events", "auto");
  }, 200);
}

MethodService.formatMoney = function (value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

MethodService.getToken = function () {
  return window.localStorage.getItem(
    "mushroom.tokens[" + window.MyConfig.hostApi + "]"
  );
};

MethodService.checkToken = function (token) {
  if (token == null) {
    return MethodService.getToken();
  } else {
    return token;
  }
};

MethodService.checkRole = function (stringRoles) {
  if (!window.localStorage.currentUser) {
    return false;
  }
  var currentUser = JSON.parse(window.localStorage.currentUser);
  let roles = stringRoles.split(",");
  var flag = false;
  roles.forEach(function (item) {
    item = item.trim();
    if (currentUser.roles.indexOf(item) != -1) {
      flag = true;
    }
  });
  return flag;
};

MethodService.getCurrentUser = function () {
  return JSON.parse(window.localStorage.currentUser);
};
MethodService.getCurrentUserBS = function () {
  return JSON.parse(window.localStorage.currentUserBS);
};

MethodService.element = {
  datepicker: {
    formatDate: "dd/MM/yyyy",
    formatDatetime: "dd/MM/yyyy HH:mm",
    valueFormat: "yyyy-MM-ddTHH:mm:ss",
    placeholderDate: "Ngày/Tháng/Năm",
    placeholderDatetime: "Ngày/Tháng/Năm Giờ:Phút",

    formatMonth: "MM/yyyy",
    placeholderMonth: "Tháng/Năm",
    formatYear: "yyyy",
    placeholderYear: "Năm"
  }
};

//required iso 9001 ex: yyyy-dd-mmThh:mm:ssZ
let formatDateMoment = "DD/MM/YYYY";

//ex: iso date to string date  yyyy-dd-mmThh:mm:ssZ - > DD/MM/YYYY
//ex: new Date to iso date  Wed Mar 25 2015 07:00:00 GMT+0700 (Giờ Đông Dương) - > yyyy-dd-mmThh:mm:ssZ || MethodService.formatDate(new Date, "")
MethodService.formatDate = function (value, rule) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm";
    } else {
      format = rule;
    }
    return moment(value).format(format);
  } else {
    return "";
  }
};

MethodService.formatDate2 = function (value, rule, z) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm";
    } else {
      format = rule;
    }
    return moment(value, z).format(format);
  } else {
    return "";
  }
};

MethodService.formatTimestamp = function (value, rule) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm";
    } else {
      format = rule;
    }
    return moment(value, "YYYY:MM:DDTHH:mm:ss.SSSZZ").format(format);
  } else {
    return "";
  }
};

//value mush is "DD/MM/YYYY"
MethodService.formatStringToIsoDate = function (value) {
  return moment(value, "DD/MM/YYYY").format();
};

MethodService.checkIsoDate = function (value) {
  return RegExp(
    /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/
  ).test(value);
};

MethodService.getAboutTime = function (value) {
  if (value) {
    let timeAgo = moment(value).fromNow();
    timeAgo = timeAgo
      .replace("a few seconds ago", "vài giây trước")
      .replace("minutes ago", "phút trước")
      .replace("hours ago", "giờ trước");
    return timeAgo;
  } else {
    return "";
  }
};

//value mush is Iso date
MethodService.getDay = function (value) {
  if (value) {
    return moment(value, "YYYY-MM-DD").get("date");
  } else {
    return "";
  }
};
MethodService.getMonth = function (value) {
  if (value) {
    return 1 + moment(value, "YYYY-MM-DD").get("month");
  } else {
    return "";
  }
};
MethodService.getYear = function (value) {
  if (value) {
    return moment(value, "YYYY-MM-DD").get("year");
  } else {
    return "";
  }
};

//ex: MethodService.findItem(listProvince, id, "123"); return item;
MethodService.findItem = function (arr, attrFind, val) {
  return arr.find(item => {
    return val == item[attrFind];
  });
};

// ex: moment('2020-03-30T00:00:00).add(1, 'days').format("YYYY-MM-DDTHH:mm:ss");
// years quarters	months weeks	days	hours	minutes	seconds	milliseconds
MethodService.addDate = function (value, type, numberTime) {
  if (!value) {
    return "";
  }
  return moment(value)
    .add(numberTime, type)
    .format("YYYY-MM-DDTHH:mm:ss");
};

MethodService.getDate = function () {
  let res = moment().format("YYYY-MM-DD") + "T00:00:00";
  return res;
};

MethodService.formatterTrimString = function (
  row,
  column,
  cellValue,
  index,
  number
) {
  if (!number) {
    number = 8;
  }
  var lengthAllow = (column.width ? column.width : column.realWidth) / number;
  if (cellValue) {
    if (cellValue.length > lengthAllow) {
      return cellValue.slice(0, lengthAllow) + "...";
    } else {
      return cellValue;
    }
  } else {
    return "";
  }
};

MethodService.formatterFloatNumber = function (row, column, cellValue, index) {
  if (cellValue) {
    cellValue = parseFloat(cellValue).toFixed(2);
    return cellValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
};

MethodService.stringToObject = function (value) {
  let stringObj = decodeURI(value)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/<=/g, '":"')
    .replace(/>=/g, '":"')
    .replace(/=/g, '":"')
    .replace(/:regex_i:/g, '":"')
    .replace(/:regex:/g, '":"')
    .replace(/</g, '":"')
    .replace(/>/g, '":"')
    .replace(/:in:/g, '":"');
  let specialCharactersRegex = /[\&\$\(\)\*\+\/\\\?\[\]\^\|]/g;
  let match = value.match(specialCharactersRegex);
  $.each(match, (key, valueRegex) => {
    let string = "\\" + valueRegex;
    stringObj = stringObj.replace(string, valueRegex);
  })
  return JSON.parse(
    '{"' + stringObj + '"}'
  );
};

MethodService.CalculationYear = function (type, last, next) {
  var toGo = "";
  var yearNow = new Date();
  var limit = yearNow.getFullYear();
  if (type == "last") {
    toGo = last;
  }
  if (type == "next") {
    toGo = next;
    limit = limit + next - 1;
  }
  if (type == "last-next") {
    toGo = next + last;
    limit = limit + next - 1;
  }
  var arr = [];
  for (let i = 0; i < toGo; i++) {
    arr.push(limit - i);
  }
  return arr;
};

MethodService.beforeAvatarUpload = function (file, mb) {
  return file.size / 1024 / 1024 < mb;
};

MethodService.EndYearBind = function (startYear) {
  let arr = [];
  let setYear = new Date();
  let yearPresent = setYear.getFullYear();

  if (startYear) {
    let rangToYearStart = yearPresent - startYear;
    if (rangToYearStart <= 20) {
      for (let i = rangToYearStart; i >= 1; i--) {
        arr.push(startYear + i);
      }
    } else {
      for (let i = 20; i <= 1; i) {
        arr.push(startYear + i);
      }
    }
  } else {
    for (let i = 0; i < 20; i++) {
      arr.push(yearPresent - i);
    }
  }

  return arr;
};

MethodService.StartYearBind = function (endYear) {
  let arr = [];
  let setYear = new Date();
  let yearPresent = setYear.getFullYear();
  if (endYear) {
    let rangToYearStart = endYear - Number(2000);
    if (rangToYearStart <= 20)
      for (let i = 1; i < rangToYearStart; i++) {
        arr.push(endYear - i);
      }
  } else {
    for (let i = 1; i < 20; i++) {
      arr.push(yearPresent - i);
    }
  }
  return arr;
};

MethodService.stopLadda = function () {
  setTimeout(function () {
    Ladda.stopAll();
  }, 100);
};

MethodService.checkFileSize = function (file, mb) {
  return file.size / 1024 / 1024 < mb;
};

MethodService.isString = function (value) {
  return typeof value === "string" || value instanceof String;
};

MethodService.isNumber = function (value) {
  return typeof value === "number" && isFinite(value);
};

MethodService.isArray = function (value) {
  return value && typeof value === "object" && value.constructor === Array;
};

MethodService.isFunction = function (value) {
  return typeof value === "function";
};

MethodService.isObject = function (value) {
  return value && typeof value === "object" && value.constructor === Object;
};

MethodService.isDate = function (value) {
  return value instanceof Date;
};

MethodService.isBoolean = function (value) {
  return typeof value === "boolean";
};

MethodService.isNull = function (value) {
  return value === null;
};

MethodService.isUndefined = function (value) {
  return typeof value === "undefined";
};

MethodService.checkIsDate = function (day, month, year) {
  var d = parseInt(day);
  var m = parseInt(month);
  var y = parseInt(year);

  var date = new Date(y, m - 1, d);
  if (
    date.getFullYear() == y &&
    date.getMonth() + 1 == m &&
    date.getDate() == d
  ) {
    return true;
  }
  return false;
};

MethodService.copyObject = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

// so sánh 2 object khởi tạo và object trả về, nếu trả về thiếu trường thì lấy trường từ object khởi tạo gán vào objetc trả về
MethodService.checkDifferentObject = function (objectOld, objectNew) {
  function forObject(objectOld) {
    $.each(objectOld, function (key_objectOld, value_objectOld) {
      if (MethodService.isUndefined(objectNew[key_objectOld])) {
        objectNew[key_objectOld] = objectOld[key_objectOld];
      } else if (MethodService.isNull(objectNew[key_objectOld])) {
        objectNew[key_objectOld] = objectOld[key_objectOld];
      } else {
        if (MethodService.isObject(value_objectOld)) {
          forObject(value_objectOld);
        }
      }
    });
  }
  forObject(objectOld);
  return objectNew;
};

// Tìm các phần tử khác nhau có trong mảng object trả về [],
// nếu truyền [object] thì truyển thêm field
// nếu truyền array thì k cần
MethodService.findListItemDifferent = function (arrItem, field) {
  let arrItemNew = [];
  if (field) {
    arrItem.forEach((item, index) => {
      if (field) {
        if (item[field]) {
          if (arrItemNew.indexOf(item[field]) == -1) {
            arrItemNew.push(item[field]);
          }
        }
      } else {
        if (arrItemNew.indexOf(item) == -1) {
          arrItemNew.push(item);
        }
      }
    });
    return arrItemNew;
  } else {
    return arrItem.filter((item, index) => {
      return arrItem.indexOf(item) === index;
    });
  }
};

MethodService.findListItemDuplicate = function (arrItem1, arrItem2) {
  return arrItem1.filter(function (val) {
    return arrItem2.indexOf(val) != -1;
  });
};

MethodService.markdownOption = {
  previewStyle: "vertical", //tab | vertical
  mode: "markdown",
  options: {
    minHeight: "200px",
    language: "vi_VN",
    useCommandShortcut: true,
    useDefaultHTMLSanitizer: true,
    usageStatistics: false,
    hideModeSwitch: true,
    placeholder: "Nhập nội dung...",
    toolbarItems: [
      "heading",
      "bold",
      "italic",
      "strike",
      "divider",
      "hr",
      "quote",
      "divider",
      "ul",
      "ol",
      "task",
      "indent",
      "outdent",
      "divider",
      "table",
      // 'image',
      "link",
      "divider",
      "code"
      // 'codeblock'
    ]
  }
};

MethodService.markdownModel = {
  dialogImage: false,
  dialogImageTab: "insert",
  dataFormImage: {
    title: null,
    link: null,
    file: null
  },
  validFormImage: {
    title: [],
    link: [],
    file: []
  }
};

MethodService.replaceURLImage = function (value) {
  return value.replace(
    /!\[([^\]]*)\]\(([^\]]*)([0-9a-fA-F]{24})\)/,
    "![$1]($3)"
  );
};

MethodService.unreplaceURLImage = function (value) {
  return value.replace(
    /!\[([^\]]*)\]\(([0-9a-fA-F]{24})\)/,
    `![$1](${ExtensionService.urlImg}$2)`
  );
};

MethodService.readExcel = function (dataFile) {
  return new Promise(function (resolve, reject) {
    blockUi();
    readXlsxFile(dataFile).then((rows) => {
      resolve(rows);
      unblockUi()
    }, (error) => {
      toastr.error("Đọc file không thành công");
      unblockUi();
    });
  })

};

MethodService.checkSDT = function (value) {
  return RegExp(/^(0|\+?84|0084)\d{9}$/).test(value);
};

MethodService.filterTable = function (jsonFilter) {
  if (jsonFilter) {
    let dataSearch = JSON.parse(jsonFilter);
    let filters = "";
    $.each(dataSearch.value, (key, value) => {
      if (value) {
        if (dataSearch.operator[key]) {
          let operator = dataSearch.operator[key];
          console.log(value);

          let valueChange = value.replace("*", "\\*"); //Sửa lỗi tìm dấu *
          if (operator == "<+1day") {
            operator = "<";
            valueChange = MethodService.addDate(value, "days", 1);
          }
          if (operator.includes("regex")) {
            let specialCharactersRegex = /[#&\$\(\)\*\+\/\\\?\[\]\^\|]/g;
            let match = value.match(specialCharactersRegex);
            let special = '#&\\';
            $.each(match, (key, valueRegex) => {
              let string = (special.includes(valueRegex) ? "\\\\\\" : "\\") + valueRegex;
              valueChange = valueChange.replace(valueRegex, string);
            })
            console.log(valueChange);
          }
          filters += key + operator + valueChange + "&";
        } else {
          filters += key + "=" + value + "&";
        }
      }
    });
    return filters.slice(0, -1);
  } else {
    return "";
  }
};

MethodService.sortObjectByKeyDate = function (obj, type) {
  var unordered = obj;
  var ordered = {};

  let keys = Object.keys(unordered);

  if (type == "asc") {
    keys
      .sort(function (a, b) {
        return new Date(a) - new Date(b);
      })
      .forEach(function (key) {
        ordered[key] = unordered[key];
      });
  }
  if (type == "desc") {
    keys
      .sort(function (a, b) {
        return new Date(b) - new Date(a);
      })
      .forEach(function (key) {
        ordered[key] = unordered[key];
      });
  }

  return ordered;
};

MethodService.sortObjectByKeyDate2 = function (obj, type) {
  var unordered = obj;
  var ordered = {};

  let keys = Object.keys(unordered);

  if (type == "asc") {
    keys
      .sort(function (a, b) {
        return new Date(
          a.substring(6, 10),
          parseInt(a.substring(3, 5)) - 1,
          a.substring(0, 2)
        ).getTime() -
          new Date(
            b.substring(6, 10),
            parseInt(b.substring(3, 5)) - 1,
            b.substring(0, 2)
          ).getTime();
      })
      .forEach(function (key) {
        ordered[key] = unordered[key];
      });
  }
  if (type == "desc") {
    keys
      .sort(function (a, b) {
        return new Date(
          b.substring(6, 10),
          parseInt(b.substring(3, 5)) - 1,
          b.substring(0, 2)
        ).getTime() -
          new Date(
            a.substring(6, 10),
            parseInt(a.substring(3, 5)) - 1,
            a.substring(0, 2)
          ).getTime();
      })
      .forEach(function (key) {
        ordered[key] = unordered[key];
      });
  }

  return ordered;
};

MethodService.createGuid = function () {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  // then to call it, plus stitch in '4' in the third group
  let guid = (
    S4() +
    S4() +
    "-" +
    S4() +
    "-4" +
    S4().substr(0, 3) +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  ).toLowerCase();
  return guid;
};

MethodService.soSanhVoiNgayHomNay = function (value) {
  let now = new Date();
  let dayNow = moment(now).format("YYYYMMDD");
  let day = moment(value)
    .add(1, "day")
    .format("YYYYMMDD");
  return dayNow < day;
};

MethodService.checkIsNullObject = function (obj) {
  let flag = true;
  for (let key in obj) {
    let val = obj[key];
    if (val) {
      flag = false;
      return;
    }
  }
  return flag;
};
MethodService.formatDate3 = function (value) {
  if (!value) {
    return "";
  }
  return moment(value).format("DD-MM-YYYY");
};
MethodService.trimFormData = function (formData) {
  return JSON.parse(JSON.stringify(formData).replace(/"\s+|\s+"/g, '"'));
};
MethodService.trimTextData = function (textData) {
  return textData.replace(/^\s+ |\s+$/g, "");
};
MethodService.NgaySinhSlice = function (value) {
  return `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(
    6,
    8
  )}T00:00:00`;
};
MethodService.checkTokenTichHop = token => {
  if (window.localStorage.getItem("token")) {
    return window.localStorage.getItem("token");
  } else {
    return token;
  }
};

MethodService.change_alias = (alias) => {
  var str = alias;
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
  str = str.replace(/ + /g, " ");
  str = str.trim();
  return str;
};

MethodService.checkIsFileImage = (value) =>{
  let count = 0;
  ['.jpg', '.jpeg', '.png'].forEach(element => {
    if (value.toLowerCase().includes(element)) {
      count = count + 1;
    }
  });
  if (count > 0) {
    return true;
  } else {
    return false;
  }
};

MethodService.exportExcel = function (dataList) {
  let workbook = new Excel.Workbook();
  workbook.created = new Date();
  workbook.calcProperties.fullCalcOnLoad = false;
  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 10000,
      height: 20000,
      firstSheet: 0,
      activeTab: 0,
      visibility: "visible"
    }
  ];


  //Tạo sheet DS KDL
  let worksheet = workbook.addWorksheet("DS Bác sĩ", {
    views: [{ state: "frozen", xSplit: 2, ySplit: 3 }]
  });
  // let worksheet = workbook.getWorksheet('DS Khách du lịch');

  worksheet.columns = [
    { header: "Tên bác sĩ", key: "first_name", width: 20 },
    { header: "Họ đệm", key: "last_name", width: 30 },
    { header: "Mã bệnh viện", key: "hospital_code", width: 20 },
    { header: "Tên bệnh viện", key: "hospital_name", width: 40 },
    { header: "Chứng chỉ hành nghề", key: "license_code", width: 20 },
    { header: "Ghi chú", key: "note", width: 100 },
  ];

  let row = worksheet.getRow(1);
  row.eachCell(function (cell, colNumber) {
    row.getCell(colNumber).font = { bold: true };
    row.getCell(colNumber).alignment = {
      vertical: "middle",
      horizontal: "center"
    };
  });

  $.each(dataList, (index, element) => {
    let item = {};
    item.first_name = element.first_name ? element.first_name : "";
    item.last_name = element.last_name ? element.last_name : "";
    item.hospital_code = element.hospital_code ? element.hospital_code : "";
    item.hospital_name = element.hospital_name ? element.hospital_name : "";
    item.license_code = element.license_code ? element.license_code : "";
    item.note = element.note ? element.note : "";
    worksheet.addRow(item);
  });

  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    FileSaver.saveAs(blob, "DSBacSiVien.xlsx");
  });
}

export default MethodService;
